import React, { Component } from 'react';
import {
    Container,
    withStyles,
    Grid,
    Button,
    Paper
} from '@material-ui/core';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import ModalWall from '../modals/wall';
import WallTable from '../table/wall';
import { Link } from 'react-router-dom';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import FeedbackIcon from '@material-ui/icons/Feedback';

const styles = (theme: any) => ({
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        flexGrow: 1
    },
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(6)
    }
});

interface Props {
    classes: any;
}

interface State {
    addWallOpen: boolean;
    editItemId: string | null;
}

class Walls extends Component<Props, State> {
    state: State = {
        addWallOpen: false,
        editItemId: null
    }
    constructor(props: Props){
        super(props);
        this.addWallModalOpenHandler = this.addWallModalOpenHandler.bind(this);
        this.editItem = this.editItem.bind(this);
    }
    
    public editItem(id:string){        
        this.setState({...this.state, editItemId: id, addWallOpen: !this.state.addWallOpen});
    }
    public addWallModalOpenHandler(){
        this.setState({...this.state, addWallOpen: !this.state.addWallOpen, editItemId:null});
    }

    public render() {
        const { classes } = this.props;
        const {addWallOpen, editItemId} = this.state;
        return (
            <Container maxWidth="lg" className={classes.container}>
                <Paper className={classes.paper}>
                <Grid container>
                    <Grid item xs={6} sm={6}>
                        <img alt="org logo" src="https://pancan.org/wp-content/uploads/2018/05/pancan-logo.png"  />
                    </Grid>
                    <Grid item xs={6} sm={6} container
                        direction="row"
                        justify="flex-end"
                        alignItems="center">
                        <Button variant="outlined" onClick={this.addWallModalOpenHandler} color="primary" endIcon={<ViewComfyIcon />}>Add Wall</Button>&nbsp;&nbsp;
                        <Link to="/tags" style={{textDecoration: 'none'}}><Button variant="outlined" onClick={this.addWallModalOpenHandler} color="secondary" endIcon={<LocalOfferIcon />}>Add Tag</Button></Link>&nbsp;&nbsp;
                        <Link to="/alerts" style={{textDecoration: 'none'}}><Button variant="outlined" onClick={this.addWallModalOpenHandler} color="primary" endIcon={<FeedbackIcon />}>Add Alert</Button></Link>
                    </Grid>
                </Grid>
                </Paper>                
                <WallTable editItem={this.editItem}/>
                {addWallOpen? <ModalWall isOpen={addWallOpen} toggler={this.addWallModalOpenHandler} editItemId={editItemId}/>:null}
            </Container>
        );
    }
}

export default withStyles(styles)(Walls);